import React, { useCallback, useMemo } from 'react';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';

// Components
import { Text } from '@beef/ui-kit';

// Utils
import { priceWithDiscount, priceWithDate, getPrice, displayedPriceText } from '../../utils';

// Styles
import styles from './styles.pcss';

const cn = classNames.bind(styles);
const textFree = 'Бесплатно';

const HeaderFamily = ({ title, price, unit, discount }) => {
  const discountPrice = priceWithDiscount(discount, unit);
  const discountPriceWithDate = priceWithDate(discount, discountPrice);
  const displayedDescription = displayedPriceText(discountPriceWithDate, price, unit);
  const priceBeforeDiscount = getPrice(discount?.priceWithoutDiscount, unit, '', textFree);
  // Если бесплатно, то не показывать зачеркнутый тект с текстом "Бесплатно"
  const showPriceBeforeDiscount = textFree !== priceBeforeDiscount;

  return (
    <div className={cn('title')}>
      <Text
        color="grey95"
        size="size3-m"
        tagType="h2"
      >
        {title}
      </Text>
      <div className={cn('title__price')}>
        {discountPrice && (
          <>
            {showPriceBeforeDiscount && (
            <Text
              color="grey50"
              crossOutColor="scarlet"
              isCrossedOut
              size="size6-r"
            >
              {priceBeforeDiscount}
            </Text>
            )}

            &nbsp;
            <Text
              color="grey95"
              size="size5-r-s"
            >
              {displayedDescription}
            </Text>
          </>
        )}
        {!discountPrice && (
          <Text
            color="grey95"
            size="size5-r-s"
          >
            {getPrice(price, unit, '', textFree)}
          </Text>
        )}
      </div>
    </div>
  );
};

HeaderFamily.propTypes = {
  title: PropTypes.string,
  price: PropTypes.objectOf({
    price: PropTypes.string,
    discount: PropTypes.string,
  }),
  unit: PropTypes.string,
  discount: PropTypes.objectOf({
    percent: PropTypes.number,
    priceWithoutDiscount: PropTypes.number,
    expirationDate: PropTypes.string,
  }),
};

export { HeaderFamily };
